import $ from 'jquery'
import vue from 'vue'
import store from './store'
import env from './../../src/common/env.js';
import { getUserOpenId } from "./openId"
export function getUserToken() {


    var token = sessionStorage.getItem("ltmUserToken");

    //token是否有效(过期)
    var userTokenIsValid = checkUserTokenTimestamp();

    var openId = '';

    // 测试用
    // var openId = "oz8T31dkJLJHNxJLPRHHv4sFM8fk";  o_RbBuGWdWQb3sre0vOmetjd5KCs  
    //生产环境
    if (env.bool) {
        openId = sessionStorage.getItem("ltmOpenId");
        //开发环境
    } else {
        openId = "oz8T31dkJLJHNxJLPRHHv4sFM8fk";
    }

    //token无效
    if (!userTokenIsValid) {
        if (openId) {
            getToken(openId);
        } else {}
    }
    //token有效
    else {
        // 有openId时才去获取token,否则获取的token是错误的,localStorage中存储的也会是错误的token
        if (openId) {
            if (!token) {
                getToken(openId);
                // resolve(true)
            } else {
                var userType = sessionStorage.getItem("ltmUserType");
                if (userType === "customer") {
                    store.commit("setCustomerStatus", true);
                }
            }
        } else {
            // console.log("Token失效且没有OpenId，无法获取token");
        }
    }

}

//调用api获取userToken
export function getToken(openId) {
    $.ajax({
        url: '/wxapi-web/getUserToken',
        type: 'get',
        async: false,
        data: {
            openid: openId
        },
        success: function(res) {

            if (res.code == 0) {
                // console.log("回调中的userType", res.data.token.user_type);
                // console.log("回调中的token", res.data.token.token);

                sessionStorage.setItem("ltmUserType", res.data.token.user_type);
                sessionStorage.setItem("ltmUserToken", res.data.token.token);

                //设置获取userToken的时间戳 => 7200秒过期
                var newTimestamp = Date.parse(new Date()) / 1000 + 60;
                sessionStorage.setItem("ltmUserTokenValidTimestamp", newTimestamp);

                // console.log("callBackUserType", res.data.token.user_type);

                if (res.data.token.user_type === "customer") {
                    store.commit("setCustomerStatus", true);
                }

            } else {
                console.log("getUserToken error");
            }

        },
        error: function() {
            console.log('错误')
        }
    })
}

//检测时间戳
function checkUserTokenTimestamp() {

    //获取token的过期时间戳
    var userTokenValidTimestamp = sessionStorage.getItem("ltmUserTokenValidTimestamp");

    // console.log("过期时间戳", userTokenValidTimestamp);

    //如果存在过期时间戳
    if (userTokenValidTimestamp) {

        //当前时间戳
        var nowTimestamp = Date.parse(new Date()) / 1000;

        //如果过期时间戳比现在的时间戳大，说明“不”需要获取新的token
        if (userTokenValidTimestamp > nowTimestamp) {
            //校验通过
            return true;
        } else {
            //token过期,需要重新获取token
            return false;
        }

    } else {
        //如果没有存储时间戳,说明还未获取userToken,校验不通过,需要调用方法获取token
        return false;
    }




}


//////////////////
// WEBPACK FOOTER
// ./static/js/userToken.js
// module id = Qkxl
// module chunks = 52